import {QueryClient, QueryClientProvider} from '@tanstack/react-query'

import {ReactQueryDevtools} from '@tanstack/react-query-devtools'
import App from './App'
import AuthProvider from './components/authentication/AuthProvider'
import {ChatProvider} from './components/chat/ChatProvider'
import {RoleProvider} from './components/role/RoleProvider'
import AppProvider from './context/app/AppContext'
import UserHospitalProvider from './context/hospital/UserHospitalContext'
import {OpenAiProvider} from './openAi/OpenAiProvider'
import {WebsocketProvider} from './websocket/WebsocketContext'

const queryClientProvider = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchInterval: 10 * 60 * 1000,
            refetchIntervalInBackground: true,
            retry: false,
            retryOnMount: false,
            keepPreviousData: true,
            networkMode: 'always',
        },
    },
})

const Main = () => {
    return (
        <QueryClientProvider client={queryClientProvider}>
            <AuthProvider>
                <AppProvider>
                    <UserHospitalProvider>
                        <WebsocketProvider>
                            <OpenAiProvider>
                                <RoleProvider>
                                    <ChatProvider>
                                        <App />
                                    </ChatProvider>
                                </RoleProvider>
                            </OpenAiProvider>
                        </WebsocketProvider>
                    </UserHospitalProvider>
                </AppProvider>
            </AuthProvider>
            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    )
}

export default Main

// App Provider
// userRole (4 Roles) - TimezoneId

// Hospital Provider
// currentHospital

// Role Provider
// myRolePermissions
